import React, { useState } from 'react';
import { Send, CheckCircle, AlertCircle } from 'lucide-react';

interface Props {
  patientPhone: string;
  messageContent: string;
  label: string;
}

export default function SendWhatsAppButton({ patientPhone, messageContent, label }: Props) {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorText, setErrorText] = useState('');

  const handleSend = async () => {
    setStatus('loading');
    setErrorText('');
    try {
      // 1. Fetch chats to match phone number
      const res = await fetch('/api/whatsapp/chats');
      const data = await res.json();
      
      const normalizedPhone = patientPhone.replace(/\D/g, '');
      const chat = data.chats.find((c: any) => c.phone.replace(/\D/g, '') === normalizedPhone);
      
      if (!chat) {
        setStatus('error');
        setErrorText('Patient not found on WhatsApp.');
        return;
      }
      
      // 2. Send message
      const sendRes = await fetch('/api/whatsapp/send-message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chatId: chat.id, message: messageContent }),
      });
      
      if (sendRes.ok) {
        setStatus('success');
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        setStatus('error');
        setErrorText('Failed to send.');
      }
    } catch (e) {
      setStatus('error');
      setErrorText('Error connecting.');
    }
  };

  return (
    <button
      onClick={handleSend}
      disabled={status === 'loading'}
      className="flex items-center gap-1.5 text-xs text-green-700 bg-green-50 px-2 py-1 rounded border border-green-200 hover:bg-green-100 disabled:opacity-50"
    >
      {status === 'idle' && <Send className="w-3 h-3" />}
      {status === 'loading' && <span className="animate-spin">...</span>}
      {status === 'success' && <CheckCircle className="w-3 h-3 text-green-600" />}
      {status === 'error' && <AlertCircle className="w-3 h-3 text-rose-600" />}
      <span>{status === 'idle' ? `Send ${label} via WA` : status === 'success' ? 'Sent!' : errorText || 'Sending...'}</span>
    </button>
  );
}
